var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C14 4 17.01 7.13 18 10C17.01 12.87 14 16 10 16C6 16 2.99 12.87 2 10C2.99 7.13 6 4 10 4ZM10 6.5C7.52 6.5 5.5 8.02 5.5 10C5.5 11.98 7.52 13.5 10 13.5C12.48 13.5 14.5 11.98 14.5 10C14.5 8.02 12.48 6.5 10 6.5ZM10 8.5C11.1 8.5 12 9.4 12 10.5C12 11.6 11.1 12.5 10 12.5C8.9 12.5 8 11.6 8 10.5C8 9.4 8.9 8.5 10 8.5Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.094a733d6964544d907e7c3eb4a91e32.svg";
export { ForwardRef as ReactComponent };